module.exports = __webpack_public_path__ + "components/city-nav/static/carrot-867048c0145dcfb5d5a7dae8a44c6301.svg";